import { mealTypes } from "./../store/meals/types";
import { MealCountKey, SiteAppInfo } from "@/models";
import { IOfflineInfo } from "@/store";
import moment from "moment";

export const OfflineInfoHelper = {
  getNonCongregateMealTypes(
    key: MealCountKey,
    siteAppDates: SiteAppInfo[]
  ): string[] {
    const mealTypes = siteAppDates
      .filter(
        (siteAppInfo) =>
          siteAppInfo.siteId === key.siteId &&
          siteAppInfo.programId === key.programId
      )
      .flatMap((siteAppInfo) =>
        siteAppInfo.years.flatMap((year) =>
          year.days.some(
            (day) => day.day === moment(key.mealServiceDate).dayOfYear()
          )
            ? [year.mealTypeId]
            : []
        )
      )
      .filter((mealType, index, self) => self.indexOf(mealType) === index);

    return this.sortMealTypes(mealTypes);
  },
  sortMealTypes(mealTypes: string[]) {
    const mealTypeSortOrder = [
      "BREAKFAST",
      "Snack_am",
      "LUNCH",
      "Snack_pm",
      "SUPPER",
    ];

    return mealTypes.sort(
      (a, b) => mealTypeSortOrder.indexOf(a) - mealTypeSortOrder.indexOf(b)
    );
  },
};
